import { render, staticRenderFns } from "./SampleSentBody.vue?vue&type=template&id=2ada7644&"
import script from "./SampleSentBody.vue?vue&type=script&lang=js&"
export * from "./SampleSentBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports